import _slicedToArray from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
// Copyright 2017-2021 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { combineLatest } from '@polkadot/x-rxjs';
import { map } from '@polkadot/x-rxjs/operators';
import { memo } from "../util/index.mjs";
/**
 * @name bestNumberLag
 * @returns A number of blocks
 * @description Calculates the lag between finalized head and best head
 * @example
 * <BR>
 *
 * ```javascript
 * api.derive.chain.bestNumberLag((lag) => {
 *   console.log(`finalized is ${lag} blocks behind head`);
 * });
 * ```
 */

export function bestNumberLag(instanceId, api) {
  return memo(instanceId, function () {
    return combineLatest([api.derive.chain.bestNumber(), api.derive.chain.bestNumberFinalized()]).pipe(map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          bestNumber = _ref2[0],
          bestNumberFinalized = _ref2[1];

      return api.registry.createType('BlockNumber', bestNumber.sub(bestNumberFinalized));
    }));
  });
}